export const infoPoints = [
  [
    { text: 'Lead automatically closed if ' },
    { text: 'inactivity', highlightRed: true },
    { text: ' & rating match the auto-return conditions.' },
  ],
  [
    { text: 'Returned to ' },
    { text: 'LeadXchange Pool', strong: true },
    { text: '.' },
  ],
  [
    { text: 'System sets close reason: ' },
    { text: '"Lead Recycled to Pool – SLA Breach"', strong: true },
    { text: '.' },
  ],
  [
    { text: 'If reclaimed by same environment: ' },
    { text: 'SLA resets', highlightGreen: true },
    { text: '.' },
  ],
];
